import { useState, useEffect } from "react";

import { FontRegister, DocStyles, LogoTavad } from "./DocStyles";

import { FormatDate } from './FormatDate';

import { useLoaderData, useParams } from "react-router-dom";

import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

export function ConInfBenzSinSegField({
  updateData,
  autoEspecialistaData,
  autoPacienteData,
  savedData,
}) {
  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  let especialistaFullName = autoEspecialistaData
    ? autoEspecialistaData?.first_name + " " + autoEspecialistaData?.last_name
    : undefined;
  let pacienteFullName = autoPacienteData
    ? autoPacienteData?.first_name + " " + autoPacienteData?.last_name
    : undefined;

  const [docResp, setDocResp] = useState(
    savedData?.docResp ? savedData?.docResp : especialistaFullName
  );
  const [docFecha, setDocFecha] = useState(
    savedData?.docFecha ? savedData?.docFecha : todayDate
  );
  const [docPacie, setDocPacie] = useState(
    savedData?.docPacie ? savedData?.docPacie : pacienteFullName
  );
  const [docDni, setDocDni] = useState(
    savedData?.docDni ? savedData?.docDni : autoPacienteData?.meta?.dni
  );

  const [docColegiado, setDocColegiado] = useState(
    savedData?.docColegiado
      ? savedData?.docColegiado
      : autoEspecialistaData?.meta?.colegiado
  );

  let data = {
    docResp: docResp,
    docFecha: docFecha,
    docPacie: docPacie,
    docDni: docDni,
    docColegiado: docColegiado,
  };

  useEffect(() => {
    updateData(data);
  }, [docResp, docFecha, docPacie, docDni, docColegiado]);

  // Data for docx generator
  const [showDocxLink, setShowDocxLink] = useState(false);

  const generateDocx = async () => {
    try {
      const response = await fetch(
        "https://app.tavad.com/documentacion-templates/ConInfBenzSinSeg.docx"
      );
      const blob = await response.blob();
      const arrayBuffer = await new Response(blob).arrayBuffer();

      const zip = new PizZip(arrayBuffer);
      const doc = new Docxtemplater(zip, {
        nullGetter() {
          return "XXXXXXXXX";
        },
      });

      doc.setData({
        responsable: docResp,
        date: FormatDate(docFecha),
        paciente: docPacie,
        dni: docDni,
        colegiado: docColegiado,
      });

      doc.render();
      const output = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      saveAs(
        output,
        "consentimiento-informado-benzodiazepinas-sin-seguimiento.docx"
      );
    } catch (error) {
      console.error("Error al generar el documento .docx", error);
    }
  };

  useEffect(() => {
    updateData(data);
    setShowDocxLink(true);
  }, [docResp, docFecha, docPacie, docDni, docColegiado]);

  return (
    <>
      <div className='docFormContainer'>
      <div className="grid--2col">
        <div className='field'>
          <label htmlFor='docResp'>Responsable</label>
          <div className='control'>
            <input
              className='input'
              id='docResp'
              required
              type='text'
              value={docResp}
              onChange={(e) => setDocResp(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docFecha'>Fecha visita</label>
          <div className='control'>
            <input
              className='input'
              id='docFecha'
              required
              type='date'
              value={docFecha}
              onChange={(e) => setDocFecha(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docPacie'>Paciente</label>
          <div className='control'>
            <input
              className='input'
              id='docPacie'
              required
              type='text'
              value={docPacie}
              onChange={(e) => setDocPacie(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docDni'>DNI Paciente</label>
          <div className='control'>
            <input
              className='input'
              id='docDni'
              required
              type='text'
              value={docDni}
              onChange={(e) => setDocDni(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docColegiado'>Número de Colegiado</label>
          <div className='control'>
            <input
              className='input'
              id='docColegiado'
              required
              type='text'
              value={docColegiado}
              onChange={(e) => setDocColegiado(e.target.value)}
            />
          </div>
        </div>
        </div>
      </div>
      <div className='btn-dwnld'>
        

        {showDocxLink && (
          <a className='button is-link' href='#!' onClick={generateDocx}>
            Descargar DOCX
          </a>
        )}
      </div>

      
    </>
  );
}


